import React from "react";
import { useForm } from "react-hook-form";
import { createPersonalFaq } from "../../../api/FAQ/PersonalFq/createPersonalQuery";
import Navbar from "../../../Components/Navbar";
import { useAuthContext } from "../../../hooks";
import PostPersonalSc from "./index.sc";

function Index() {
  const auth = useAuthContext();
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();
  const handlereatPersonalFaq = async (e: any) => {
    console.debug("data > ", e);
    await createPersonalFaq(
      auth?.userInfo?.orgs[0]?.id,
      auth?.userInfo?.orgs_user_id[0],
      {
        ...e,
        created_by: auth?.userInfo?.orgs_user_id[0],
      }
    )
      .then((e) => {
        console.log(e);
      })
      .catch((err) => {
        console.log("====================================");
        console.log(err);
        console.log("====================================");
      });
  };
  const onSubmit = async (e: any) => {
    console.log("I am Here", e);
    await handlereatPersonalFaq(e);
    reset();
  };
  return (
    <>
      <PostPersonalSc>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="input-group">
            <span className="input-group-text">Fill the concerns you have</span>
            <textarea
              className="form-control"
              aria-label="With textarea"
              {...register("query", {
                required: {
                  value: true,
                  message: "This is required",
                },
              })}
            ></textarea>
          </div>
          <div
            className="xbi4er-button"
            style={{ alignContent: "center", padding: "2rem" }}
          >
            <button type="submit" className="btn btn-primary">
              Submit Insytix'er
            </button>
          </div>
        </form>
      </PostPersonalSc>
    </>
  );
}

export default Index;
